module.exports = __webpack_public_path__ + "media/icons/map-icon-radius-de50acb3.svg";